<div class="modal-header">
    <span class="pull-right">
        <button class="btn btn-default btn-xs" (click)="closeModal()"><i class="glyphicon glyphicon-remove"></i></button>
      </span>
  <span>
    <h4 class="modal-title">{{ request.title }}</h4>
  </span> 
</div>

<div class="modal-body" [formGroup]="rejectionForm">
  <div class="form-horizontal">
    <div class="form-group">
      <label class="control-label col-sm-4">Notes</label>
      <div class="col-sm-8">
          <textarea class="form-control" maxlength="2000" rows="20" formControlName="comment"></textarea>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">

  <button class="btn btn-primary" (click)="backToDraft()" *ngIf="submittedOrAssigned">Back to Requestor</button>

  <div class="btn-group" dropdown *ngIf="readyForReview">
    <button type="button" class="btn btn-primary" (click)="backToPlanning()">Back to Planning</button>
    <button id="button-split" type="button" dropdownToggle class="btn btn-primary dropdown-toggle dropdown-toggle-split" aria-controls="dropdown-split">
      <span class="caret"></span>
    </button>
    <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-split">
      <li role="menuitem">
        <a class="dropdown-item" (click)="backToDraft()">Back to Requestor</a>
      </li>
    </ul>
  </div>

</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-rejection-modal/request-rejection-modal.component.html